module.exports = __webpack_public_path__ + "img/undraw_Newsletter_re_wrob.c9c42fb5.svg";